module.exports = __webpack_public_path__ + "img/hurling.028822bf.svg";